import { render, staticRenderFns } from "./visit-record.vue?vue&type=template&id=4fa432b0&scoped=true"
import script from "./visit-record.vue?vue&type=script&lang=js"
export * from "./visit-record.vue?vue&type=script&lang=js"
import style0 from "./visit-record.vue?vue&type=style&index=0&id=4fa432b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa432b0",
  null
  
)

export default component.exports